import { render, staticRenderFns } from "./CompItemRow.vue?vue&type=template&id=5706616e&scoped=true&"
import script from "./CompItemRow.vue?vue&type=script&lang=js&"
export * from "./CompItemRow.vue?vue&type=script&lang=js&"
import style0 from "./CompItemRow.vue?vue&type=style&index=0&id=5706616e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5706616e",
  null
  
)

export default component.exports